module.exports = __webpack_public_path__ + "static/desi-40d77496d680f7afd16dc20103bc35ae.jpg";